module.exports = __webpack_public_path__ + "static/media/ic_generate_invoice.8522eb18.svg";